export const useSpecialFunctions = () => {
  // Get the date from a UTC date and format it
  const getUTCDateInfo = (date) => {
    const postTime = new Date(date);
    return (
      ("0" + (postTime.getUTCMonth() + 1)).slice(-2) +
      "/" +
      ("0" + postTime.getUTCDate()).slice(-2) +
      "/" +
      postTime.getUTCFullYear()
    );
  };

  const isExpiringSoon = (date) => {
    if (!date) return false;

    const [year, month, day] = date.split("T")[0].split("-");

    const today = new Date();
    const expDate = new Date(year, month - 1, day);

    today.setHours(0, 0, 0, 0);

    const diffDays = (expDate - today) / (1000 * 60 * 60 * 24);

    return diffDays <= 7 && diffDays >= 0;
  };

  const getDaysLeft = (date) => {
    if (!date) return null;

    const diff =
      (new Date(date).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24);

    return Math.ceil(diff);
  };

  const getExpireText = (date) => {
    const days = getDaysLeft(date);

    if (days === 0) return "Expires today";
    if (days === 1) return "Expires tomorrow";
    return `Expires in ${days} days`;
  };

  const checkHasUpgrade = (trackPackages) => {
    if (!trackPackages?.length) return false;

    const now = new Date();

    return trackPackages.some((pkg) => {
      if (!pkg.Expiration) return false;

      const expirationDate = new Date(pkg.Expiration);

      const diffTime = expirationDate.getTime() - now.getTime();

      const diffDays = diffTime / (1000 * 60 * 60 * 24);

      return diffDays <= 7 && diffDays >= 0;
    });
  };

  return {
    getUTCDateInfo,
    isExpiringSoon,
    getDaysLeft,
    getExpireText,
    checkHasUpgrade,
  };
};
